import React, { useEffect, useState } from 'react';
import ArticleDetails from '../ArticleDetails/ArticleDetails';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Article = () => {
    const [articles, setArticles] = useState([]);

    useEffect( () => {
        Aos.init({duration: 1500})
    }, []);

    useEffect(() => {
        fetch('articleData.json')
            .then(res => res.json())
            .then(data => setArticles(data))
    }, []);

    // console.log(articles);

    return (
        <div className='w-11/12 mx-auto mt-10 '>
            <div className='flex justify-center items-center'>
                <h2 data-aos='flip-left' className='text-xl mb-5 mt-10 lg:text-4xl font-semibold text-center md:mb-5 border border-blue-600 inline-block rounded rounded-tl-full rounded-br-full px-10 py-2'>Articles</h2>
            </div>
            <div className='grid md:grid-cols-2 lg:grid-cols-3'>
                {
                    articles?.map(article => <ArticleDetails
                        key={article._id}
                        article={article}
                    ></ArticleDetails>)
                }
            </div>
        </div>
    );
};

export default Article;